"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_clients_1 = require("@unimaze/api-clients");
var mapi_1 = require("@unimaze/api-clients/lib/mapi");
var axios_1 = __importDefault(require("axios"));
var initialiseTransactionApi = function (mapiBaseUrl) {
    var apiConfig = {
        basePath: mapiBaseUrl,
    };
    var initiatedConfig = new mapi_1.Configuration(apiConfig);
    return new api_clients_1.mapi.TransactionApi(initiatedConfig);
};
var initialiseMessageApi = function (mapiBaseUrl) {
    var apiConfig = {
        basePath: mapiBaseUrl,
    };
    var initiatedConfig = new mapi_1.Configuration(apiConfig);
    return new api_clients_1.mapi.MessageApi(initiatedConfig);
};
var submitDocument = function (data, attachDocument, mapiBaseUrl, apiKey) {
    var messageId = attachDocument.messageId, name = attachDocument.name, contentType = attachDocument.contentType, more = attachDocument.more;
    var headers = __assign({}, (apiKey && { Authorization: "Bearer " + window.btoa(apiKey) }), { "Content-Type": "application/octet-stream", "X-test": "test" });
    return axios_1.default.post(mapiBaseUrl + "/api/v1/messages/" + messageId + "/documents", data, {
        params: {
            name: name,
            contentType: contentType,
            more: more
        },
        headers: headers
    });
    // const messageApi = initialiseMessageApi(mapiBaseUrl);
    //
    // const options = createOptionsData(data, apiKey)
    // return messageApi.addDocuments(
    //     messageId,
    //     name,
    //     contentType,
    //     more,
    //     undefined,
    //     undefined,
    //     undefined,
    //     options
    // )
};
exports.submitDocument = submitDocument;
var submitDocumentFetch = function (data, attachDocument, mapiBaseUrl, apiKey) {
    var messageId = attachDocument.messageId, name = attachDocument.name, contentType = attachDocument.contentType, more = attachDocument.more;
    var headers = {
        Authorization: "Bearer " + window.btoa(apiKey),
        "Content-Type": "application/octet-stream",
        "X-test": "test",
    };
    var responsePromise = fetch(mapiBaseUrl + "/api/v1/messages/" + messageId + "/documents?Name=" + name + "&ContentType=" + contentType + "&More=" + more, {
        method: "POST",
        headers: headers,
        body: data
    });
    return responsePromise;
};
exports.submitDocumentFetch = submitDocumentFetch;
var submitInvoice = function (createSubmitInvoice, mapiBaseUrl, apiKey, callName, language) {
    var transactionApi = initialiseTransactionApi(mapiBaseUrl);
    var messageId = createSubmitInvoice.messageId, more = createSubmitInvoice.more, conversationIdentifier = createSubmitInvoice.conversationIdentifier, processingMode = createSubmitInvoice.processingMode, services = createSubmitInvoice.services, invoiceMetadataInput = createSubmitInvoice.invoiceMetadataInput;
    return transactionApi.createSubmitInvoice(messageId, more, conversationIdentifier, processingMode, services, invoiceMetadataInput, createOptions(apiKey, callName, language));
};
exports.submitInvoice = submitInvoice;
var createOptions = function (apiKey, callName, language) {
    return __assign({ headers: {
            "Accept-Language": language ? language : "en",
            Authorization: "Bearer " + window.btoa(apiKey)
        } }, (callName && { cancelToken: exports.getCancelToken(callName) }));
};
var createOptionsData = function (data, apiKey, callName, language) {
    var options = __assign({}, (callName && { cancelToken: exports.getCancelToken(callName) }), { data: data, headers: {
            "Accept-Language": language ? language : "en",
            Authorization: "Bearer " + window.btoa(apiKey),
            "Content-Type": "application/octet-stream"
        } });
    return options;
};
exports.getCancelToken = function (callName) {
    var cancelTokenSource = window[callName];
    if (cancelTokenSource) {
        cancelTokenSource.cancel("only one call allowed. Canceling previous call");
    }
    window[callName] = axios_1.default.CancelToken.source();
    return window[callName].token;
};
